import { Chip, ChipProps } from '@material-ui/core';

import { IdentityRefFragment } from '@spotify/confidence-graphql';

import { IdentityAvatar } from '../IdentityAvatar';

type IdentityChipProps = ChipProps & {
  identityRef: IdentityRefFragment;
};

export const IdentityChip = (props: IdentityChipProps) => {
  const { identityRef, ...rest } = props;

  return (
    <Chip
      avatar={<IdentityAvatar identityRef={identityRef} />}
      label={identityRef.displayName}
      {...rest}
    />
  );
};
